//
//
//
//
//
//
//

	export default {
		props: {
			maxLength: {
				type: Number,
				default: 100
			},
			showInput: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				marks: {}
			}
		},
		methods: {
			// 设置marks
			setStep(maxLength) {
				let marks = {}
				if( maxLength > 5 ) {
					for (let index = 0; index <= 5; index++) {
						let maskValue = Math.trunc( maxLength / 5 * index  )
						let maskWidth = maskValue / maxLength * 100
						marks[`${maskValue}`] = maskWidth
					}
				}else {
					for (let index = 0; index <= maxLength; index++) {
						let maskValue = index
						let maskWidth = maskValue / maxLength * 100
						marks[`${maskValue}`] = maskWidth
					}
				}
				this.marks = marks
			}
		},
		watch: {
			maxLength (val) {
				this.setStep(val)
			}
		},
		created() {
			this.setStep(this.maxLength)
		}
	}
